import './load-documents.scss';

import { useMemo } from 'react';

import { Button } from '@/components/Shared/ui';
import { ReloadOutlined } from '@/media/antd-icons';
import DownloadIcon from '@/media/icons/download.svg?react';
import FetchPolicies from '@/media/icons/fetch-policies.svg?react';
import RefreshIcon from '@/media/icons/refresh.svg?react';
import { useAppSelector } from '@/store';

import useLoadDocuments from '../../hooks/useLoadDocuments';
import useDownloadAllFiles from './hooks/useDownloadAllFiles';
import useEurasStatus from './hooks/useEurasStatus';

const DocumentButton = ({ label }: { label: string }) => {
  const { isFilesLoading, handleLoadEuBankFiles } = useLoadDocuments();

  return (
    <Button
      className="load-documents__action"
      size="small"
      onClick={handleLoadEuBankFiles}
      isLoading={isFilesLoading}
    >
      <span className="load-documents__action-text">{label}</span>
      {!isFilesLoading && (
        <>
          <RefreshIcon className="load-documents__action-desktop-icon" />
          <FetchPolicies className="load-documents__action-icon" />
        </>
      )}
    </Button>
  );
};

const LoadDocuments: React.FC = () => {
  const selectedBank = useAppSelector(
    (state) => state.financingStep.selectedBank
  );
  const { banksOffers, leasingOffers } = useAppSelector(
    (state) => state.offerStep
  );

  const { downloadingFiles, handleDownloadFiles } = useDownloadAllFiles();
  const { updateStatusLoading, handleChangeEuBankStatus } = useEurasStatus();

  const isHasFinancedOffer: boolean = useMemo(
    () =>
      banksOffers.some((offer) => offer.status.code === 'financed') ||
      leasingOffers.some((offer) => offer.status.code === 'financed'),
    [banksOffers, leasingOffers]
  );

  const bankName = selectedBank?.bank.name;

  return (
    <div className="load-documents">
      {selectedBank?.bank.name !== 'eu_bank_v2' && (
        <Button
          className="load-documents__action"
          size="small"
          onClick={handleDownloadFiles}
          isLoading={downloadingFiles}
        >
          <span className="load-documents__action-text">
            Скачать все документы
          </span>
          {!downloadingFiles && <DownloadIcon />}
        </Button>
      )}

      {!isHasFinancedOffer || bankName !== 'forte' ? (
        <DocumentButton label="Запросить документы" />
      ) : bankName === 'forte' ? (
        <DocumentButton label="Получить ПП" />
      ) : null}

      {selectedBank?.bank.name === 'eu_bank_v2' && (
        <Button
          className="euras-bank__update-status"
          size="small"
          onClick={handleChangeEuBankStatus}
          isLoading={updateStatusLoading}
          isReversed
        >
          Обновить статус
          {!updateStatusLoading && <ReloadOutlined />}
        </Button>
      )}
    </div>
  );
};

export default LoadDocuments;
